export type LocalStorageKeys =
    | 'TRANSMISSIONS_FETCH_LIMIT_LOCALSTORAGE_KEY'
    | 'PARTICIPANT_VIDEO_POS_KEY'
    | 'webcam'
    | 'pushConformityLater'
    | 'microphone'
    | 'speaker'
    | 'lastNetworkTestDate'
    | 'savedLastFeatureDate'
    | 'pickedVersion'
    | 'sessionToken'
    | 'SHOW_TRANSMISSION_LIMIT_DIALOG_KEY'

class LocalStorageManager<K extends string> {
    private keys: Set<K>

    private localStorage = localStorage ?? window.localStorage

    constructor() {
        this.keys = new Set()
    }

    private removeItem(key: K) {
        if (localStorage.getItem(key)) {
            this.localStorage.removeItem(key)
        }

        if (this.keys.has(key)) {
            this.keys.delete(key)
        }
    }

    set(key: K, value: string) {
        this.keys.add(key)
        this.localStorage.setItem(key, value)
    }

    get(key: K): string | null {
        return this.localStorage.getItem(key)
    }

    clear(): void {
        this.localStorage.clear()
    }

    remove(key: K | K[]) {
        if (Array.isArray(key)) {
            key.forEach((k) => {
                this.removeItem(k)
            })
        } else {
            this.removeItem(key)
        }
    }

    getKeys(): K[] {
        return Array.from(this.keys)
    }
}
export const localStorageManager = new LocalStorageManager<LocalStorageKeys>()
